import { styled } from '@mui/material/styles';
import {Stack, Typography, Box} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import LanguageIcon from '@mui/icons-material/Language';
import EmailIcon from '@mui/icons-material/Email';

const FooterContainer = styled(Box)({
  color: '#777',
  textAlign: 'center',
  position: 'inherit',
  bottom: '0',
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  padding: '2rem',
  paddingTop: '3rem'
});

const SocialIcon = styled(Box)({
  color: '#777',
  cursor: 'pointer',
  '&:hover': {
    color: '#3b5998' // Facebook blue for example
  }
});

const OfpLogo = styled('img')({
  cursor: 'pointer',
  opacity: 0.7,
  '&:hover': {
    opacity: 1
  }
});

export function Footer() {

  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noreferrer');
  };

  return (
    <FooterContainer>
      <Stack>
        <Stack direction='row' paddingLeft={1} spacing={1} justifyContent='center'>
          <Typography variant='caption' color='inherit'>
            verify.modnug &copy; {new Date().getFullYear()} All rights reserved.
          </Typography>
          <Stack direction='row' paddingLeft={1} spacing={1} justifyContent='center'>
            <SocialIcon
              component={FacebookIcon}
              fontSize='inherit'
              onClick={() => openInNewTab('https://www.facebook.com/modNUG')}
            />
            <SocialIcon
              component={LanguageIcon}
              fontSize='inherit'
              onClick={() => openInNewTab('https://mod.nugmyanmar.org/')}
            />
            <SocialIcon
              component={EmailIcon}
              fontSize='inherit'
              onClick={() => openInNewTab('mailto:mod@nugmyanmar.org')}
            />
          </Stack>
        </Stack>

        <Stack direction='row' paddingLeft={1} spacing={1} justifyContent='center'>
          <Typography variant='caption' color='inherit'>
          ပြည်သူ့တော်လှန်ရေးထောက်ပို့တပ် - PRF program is supported by OFP 
          </Typography>
          <OfpLogo
            src="https://cdn.crphofp.org/generic/ofp/logos/ofp/ofp_logo-gray777.png"
            height="16" 
            alt="ofp" 
            onClick={() => openInNewTab('https://www.facebook.com/crph.ofp.official')}
          />         
        </Stack>
      </Stack>
    </FooterContainer>
  );
}